import WebsiteGenerator from "./pages/GenerateWebsitePage";

function App() {
    return <WebsiteGenerator />;
}

export default App;